export default {
  namespaced: true,
  state: {
    isLoading: false
  },
  mutations: {
    setLoading(state, loading) {
      state.isLoading = loading
    }
  }
}